import React, { Component } from "react";
import { Grid } from "@mui/material";
import SignOutButtonWrapper from "./SignOutButton";
import { MsalConsumer } from "@azure/msal-react";

class HelpButton extends Component {
  render() {
    return (
      <a
        href="https://github.com/GM-SDV/MPSTR_232829_mapster/blob/main/docs/demo_client_user_guide.md"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button>Help</button>
      </a>
    );
  }
}

class Header extends Component {
  render() {
    return (
      <MsalConsumer>
        {({ accounts }) => (
          <div>
            <Grid container spacing={1}>
              <Grid item md={10}>
                <h1>Mapster</h1>
              </Grid>
              <Grid item md={2}>
                <div style={{ marginTop: "20px", float: "right" }}>
                  <div>Welcome: {accounts[0] && accounts[0].name}</div>
                  <div>
                    <SignOutButtonWrapper />
                  </div>
                  <div>
                    <HelpButton />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        )}
      </MsalConsumer>
    );
  }
}

export default Header;
